<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text>
      {{ is_criteria ? 'Импорт и группировка критериев' : 'Импорт и группировка КИМов' }}
    </template>

    <template #default="{ form }">
      <v-overlay :value="isLoading" absolute color="white">
        <v-progress-circular :size="50" color="primary" indeterminate />
      </v-overlay>


      <p>Если необходимо сгруппировать файлы по регионам, загрузите файл группировки</p>

      <a
        class="d-inline-block mb-4 primary--text"
        href="/files/collector-kims-grouping-template.csv"
        download
      >
        Скачать CSV шаблон для заполнения (пример)
      </a>
      <v-file-input
        v-model="form.file"
        accept="text/csv"
        label="Файл группировки"
        :loading="isLoading"
        dense
        outlined
        small-chips
        show-size
        @change="onFileSelect(form)"
      />
    </template>

    <template #footer="{ form }">
      <v-layout align-center>
        <v-btn text @click="close()" v-text="'Отменить'" />
        <v-spacer />
        <v-btn
          text
          class="mr-2"
          :disabled="!form.file"
          @click="() => onPrepareFile(form)"
          v-text="'Сгруппировать по регионам'"
        />
        <v-btn color="primary" @click="() => onSubmit()" v-text="'Продолжить без группировки'" />
      </v-layout>
    </template>
  </BModalForm>
</template>

<script>
// Components.
import BModalForm from '@/components/modals/BModalForm.vue'

// Utils.
import { CSVToArray } from '@/helpers/csv'
import { ImportKimsTasksApi } from '@/api/resources/Collector/CollectorKimsTasksImportApi'

export default {
  name: 'BaseCollectorPublicationImportKimsModal',
  components: {
    BModalForm,
  },
  props: {
    storage_id: {
      type: [String, Number],
      required: true,
    },
    criteria_storage_id: {
      type: [String, Number],
      default: null,
    },
    is_criteria: Boolean,
    collector_publication_id: {
      type: [String, Number],
      required: true,
    },
    session_digit_code: {
      type: [String, Number],
      required: true,
    },
    subject_digit_code: {
      type: [String, Number],
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    createDefaultData() {
      return {
        file: null,
      }
    },
    onFileSelect(form) {
      if (!form.file) {
        return
      }
      if (form.file.type !== 'text/csv') {
        this.$notice.errors('Поддерживаются только файлы CSV')
        this.$nextTick(() => {
          // eslint-disable-next-line no-param-reassign
          form.file = null
          this.$forceUpdate()
        })
      }
    },
    async onPrepareFile(form) {
      if (!form.file) return

      this.isLoading = true

      const text = await form.file.text()
      const rawCSV = CSVToArray(text, ';')

      /**
       * Длина одной строки
       */
      const TARGET_ROW_LENGTH = 2

      /**
       * Индекс, по которому располагается логин ОО
       */
      const OO_IDX = 0

      /**
       * Индекс, по которому располагается логин регкора
       */
      const REG_CORR_IDX = 1

      if (rawCSV[0].length !== TARGET_ROW_LENGTH) {
        this.$notice.errors('Файл CSV имеет некорректное содержание')
        this.isLoading = false
        return
      }

      const map = new Map()
      rawCSV.forEach((row, idx) => {
        if (idx === 0) {
          // Пропуск заголовка
          return
        }

        if (!Array.isArray(row) || row.length !== TARGET_ROW_LENGTH) {
          return
        }

        const oo = row[OO_IDX]
        const rc = row[REG_CORR_IDX]
        if (map.has(rc)) {
          map.get(rc).push(oo)
        } else {
          map.set(rc, [oo])
        }
      })

      await this.onSubmit(Object.fromEntries(map))

      this.isLoading = false
    },
    async onSubmit(zip = null) {
      this.isLoading = true
      try {
        const api = new ImportKimsTasksApi()
        const {
          storage_id,
          criteria_storage_id,
          collector_publication_id,
          session_digit_code,
          subject_digit_code,
          is_criteria,
        } = this
        const payload = {
          storage_id,
          session_digit_code,
          subject_digit_code,
          collector_publication_id,
          ...(is_criteria ? { criteria_storage_id, is_criteria } : {}),
        }

        if (zip) {
          payload.zip = zip
        }
        await api.importKims(payload)
        await this.close()
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
